import { render, staticRenderFns } from "./CreateNewCriteria.vue?vue&type=template&id=370463e4&scoped=true"
import script from "./CreateNewCriteria.vue?vue&type=script&lang=ts"
export * from "./CreateNewCriteria.vue?vue&type=script&lang=ts"
import style0 from "./CreateNewCriteria.vue?vue&type=style&index=0&id=370463e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370463e4",
  null
  
)

export default component.exports